export const RDY_FOR_VALIDATION = "Import In Progress"; // state#1
export const VALIDATION_IN_PROGRESS = "Import In Progress"; //after  submitted to PDF
export const VALIDATION_COMPLETE = "Import In Progress";
export const VALIDATION_FAILED = "Import Failed";  // PDF returned invalid Json file. 
export const VALIDATION_ERROR = "Import Failed";  //PDF validated  Errors returned. 
export const RDY_FOR_IMPORT = "Import In Progress";//PDF  validated, and no errors and handover to PCX
export const IMPORT_FAILURE = "Import Failed";
export const IMPORT_SUCCESS = "Import Successful";
export const IMPORT_ERROR = "Import Failed";
export const IMPORT_RUNTIME_ERROR="Import Failed";
export const IMPORT_INVALID_FILE_ERROR="Import Failed";
export const IMPORT_FAIL_EXCEED_MAX_LIMIT="Import Failed";
export const IMPORT_BAD_REQUEST_ERROR="Import Failed";
export const IMPORT_IN_PROGRESS = "Import In Progress";
export const IMPORT_FAILED = "Import Failed";
export const IMPORT_BOM_CHECKOUT_ERROR = "Import Failed";
export const IMPORT_SCHEMA_ERROR="Import Failed";
export const IMPORT_ACCESS_ERROR = "Import Failed";
export const IMPORT_SUCCESS_WARNING = "Import Successful";
export const IMPORT_SUCCESS_PARTIAL = "Import Partially Successful";
export const IMPORT_DATA_ERROR = "Import Failed";
export const FILE_TYPE_ERROR = "File should be xlsm";
export const FILE_SIZE_ERROR = "File size exceeded";
export const DUPLICATE_FILE_ERROR= "Duplicate file name";
export const READY_FOR_IMPORT_LABEL="Ready for Import";
export const BOM_JSON_ID="BOM Header";
export const BOL_JSON_ID="BOL Header";
export const SUCCESS="Success";
export const LOGIC_BOM_HEADER_SHEET_NAME="Logic BOM Header";
export const LINE_ITEM_SHEET_NAME = 'Logic BOM Line Item Detail';

export const MANDATORY_BOM_HEADER_KEYS = ['BOM ID','Logic BOM Gate','Logic BOM State', 'Template Version'];
export const MANDATORY_LINEITEM_KEYS = ['PCX Supplied Material Number','Comments','Color'];
export const PCX_SUPP_NUMBER = "PCX Supplied Material Number";
export const COMMENTS = "Comments";
export const COLOR = "Color";

export const TEMPLATEALLOWEDVERSION = '1.0';
export const TEMPLATEVERSION = "Template Version";

export const fobc = {
    contentType : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    uploadFilesMaxLimit : "1"     
};
export const nbyBom = {
    contentType : "application/vnd.ms-excel.sheet.macroEnabled.12,application/vnd.ms-excel.sheet.macroenabled.12",
    uploadFilesMaxLimit : "1"
};